/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { CONTACT_TYPE_CITY_COMPANY } from '@gh/builder-shared-data';
import { createContextRoute } from '@gh/common-internal-shared';
import {
  ContactDetailsBusinessService,
  ContactDetailsSharedCommunicationListTabComponent,
  ContactDetailsSharedCustomFieldsTabComponent,
} from '../../index';
import { ContactDetailsModel } from '../../services/contact-details-model.service';
import { ContactDetailsCityCountyFormState } from './contact-details-city-county-form.service';

@Component({
  standalone: false,
  selector: 'gh-contact-details-city-county-tab',
  templateUrl: 'contact-details-city-county-tab.component.html',
})
export class ContactDetailsCityCountyTabComponent {
  routes = [
    createContextRoute({
      component: ContactDetailsSharedCommunicationListTabComponent,
      path: 'communications',
      init: {
        service: ContactDetailsBusinessService,
        selector: 'initSharedCommunicationsTabView',
      },
      static: {
        tab: 'cityCounty',
        contactType: CONTACT_TYPE_CITY_COMPANY,
      },
    }),
    createContextRoute({
      component: ContactDetailsSharedCustomFieldsTabComponent,
      path: 'customFields',
      static: {
        tab: 'cityCounty',
      },
    }),
  ];

  constructor(public model: ContactDetailsModel,
              public form: ContactDetailsCityCountyFormState,
              public userContext: BuilderUserContext) {
  }

  get currentTab(): string {
    return <string>this.model.getSlaveTabFor('cityCounty');
  }

  onTabChanged(name: string): void {
    this.model.goToSubTab(name);
  }
}
